<template>
  <user-session-base-template :responsive-card="false">
    <z-card class="email-confirm__card" v-if="emailConfirmed">
      <div class="email-confirm__msg">
        <z-icon :icon="['far', 'check-circle']" size="extra-large" color="success" class="email-confirm__icon" />

        <z-title size="extra-small" align="left">
          Email confirmado com sucesso
        </z-title>
      </div>
      <z-link tag="router-link" :to="{ name: 'login' }" size="medium">
        Ir para o painel
      </z-link>
    </z-card>

    <z-card class="email-confirm__card" v-if="emailConfirmationFailed">
      <div class="email-confirm__msg">
        <z-icon :icon="['far', 'times-circle']" size="extra-large" color="danger" class="email-confirm__icon" />

        <z-title size="extra-small" align="left">
          Falha ao confirmar email, tente novamente mais tarde
        </z-title>
      </div>
      <z-link tag="router-link" :to="{ name: 'login' }" size="medium">
        Ir para o painel
      </z-link>
    </z-card>
  </user-session-base-template>
</template>

<script>
import UserSessionBaseTemplate from 'components/user-session-base-template';
import CurrentStudentService from 'services/CurrentStudentService';

export default {
  computed: {
    emailConfirmed() {
      return !this.loading && !this.error;
    },
    emailConfirmationFailed() {
      return !this.loading && this.error;
    },
  },
  data() {
    return {
      loading: true,
      error: false,
    };
  },
  components: {
    UserSessionBaseTemplate,
  },
  beforeMount() {
    this.$pageLoader.show();

    CurrentStudentService.confirmStudentEmail(this.$route.params.emailId)
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
        this.$pageLoader.hide();
      });
  },
};
</script>

<style lang="scss" scoped>
.email-confirm__card {
  text-align: center;
}

.email-confirm__msg {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: var(--space-large);
}

.email-confirm__icon {
  margin-right: var(--space-small);
}
</style>
